<div class="container-alerts">
  <div class="title-alerts-container menu-button">
    <h4 class="title-alerts">Synthèse du journal des alertes</h4>
    <a class="button-display-alerts" routerLink="/home/alerts">
      <app-icon [size]="Size.large" [phosphorClass]="'ph-arrow-square-in'" [color]="Color.greyBlack"></app-icon>
    </a>
  </div>
  @if (loading) {
    <div class="loading-alerts">En cours de chargement...</div>
  } @else if (error) {
    <div class="error-alerts">
      <app-report-message
        data-testid="error-log-error-message"
        [type]="alertLogLevel.ERROR"
        [message]="
          'Merci de rafraîchir la page, le journal des alertes est temporairement indisponible.' +
          'Si le problème persiste merci de prévenir les équipes.'
        "
      >
      </app-report-message>
    </div>
  } @else {
    <div class="level-alerts">
      <div class="level-title">
        <span>Par niveaux</span>
      </div>
      <div class="level">
        <div class="level-count">
          <div class="level-number">
            <app-icon [phosphorClass]="'ph-warning-circle'" [color]="Color.danger500"></app-icon>
            <span data-testid="error-counter" class="ml-07">{{ this.errorCounter }}</span>
          </div>
          <span class="level-label">{{ this.errorCounter > 1 ? 'Erreurs' : 'Erreur' }}</span>
        </div>
        <hr />
        <div class="level-count">
          <div class="level-number">
            <app-icon [phosphorClass]="'ph-warning'" [color]="Color.warning500"></app-icon>
            <span data-testid="warning-counter" class="ml-07">{{ this.warningCounter }}</span>
          </div>
          <span class="level-label">{{ this.warningCounter > 1 ? 'Avertissements' : 'Avertissement' }}</span>
        </div>
      </div>
    </div>

    <div class="category-alerts">
      <div class="category-title">
        <span class>Par catégorie</span>
      </div>
      <div class="category">
        <table id="alerts-table">
          <thead>
            <tr>
              <th>Catégorie</th>
              <th><app-icon [phosphorClass]="'ph-warning-circle'" [color]="Color.danger500"></app-icon></th>
              <th><app-icon [phosphorClass]="'ph-warning'" [color]="Color.warning500"></app-icon></th>
            </tr>
          </thead>
          <tbody>
            @for (category of alertsData | keyvalue; track category) {
              <tr>
                <td>{{ category.key }}</td>
                <td [attr.data-testid]="category.key + '-error'">{{ category.value.errors }}</td>
                <td [attr.data-testid]="category.key + '-warning'">{{ category.value.warnings }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</div>
